<template>
  <div id="userAdd">
    <!-- 个人信息-用于修改登录人的个人信息 -->
    <el-form :inline="true" class="demo-ruleForm" :model="examUser" :rules="rules" ref="examUser">
      <el-row>
        <el-col :span="8">
          <el-form-item label="用户名" prop="username" id="username" class="right">
            <el-input :disabled="true" v-model="examUser.username" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="真实姓名" prop="realname" id="realname" class="right">
            <el-input v-model="examUser.realname" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="性别" prop="sex" class="right">
            <el-select v-model="examUser.sex" placeholder="请选择" class="dialogDataWidth" style="width:100%">
              <el-option v-for="item in options_sex" :key="item.code" :label="item.value" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="手机" prop="mobile" id="mobile" class="right">
            <el-input v-model="examUser.mobile" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="座机" prop="tel" id="tel" class="right">
            <el-input v-model="examUser.tel" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="邮箱" prop="email" id="email" class="right">
            <el-input v-model="examUser.email" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 功能按钮 -->
    <el-row style="margin-top:15px">
      <el-col :span="20"><span style="visibility:hidden;">*</span></el-col>
      <el-col :span="2">
        <el-button type icon @click="reset">关闭</el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="save" @click="save">保存</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    const isMobile = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号'));
        } else {
      var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error('手机号格式不正确'))
      }else{
        callback()
      }}
    };
    return {
      options_sex: [],
      // 测试验证
      rules: {
        username: [{ required: true, message: "请填写用户名", trigger: "blur" }],
        realname: [{ required: true, message: "请填写真实姓名", trigger: "blur" }],
        mobile: [{validator:isMobile , required: true, trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }]
      }
    };
  },
  props: ["examUser"],
  mounted: function() {
    this.options_sex = this.CommonUtil.getCodeList("sex");
  },
  methods: {
    reset: function() {
      this.$emit("close");
    },
    // 保存
    save: function() {
      this.$refs["examUser"].validate(valid => {
        if (valid) {
        this.$axios.post("/user/userUpdate", this.examUser).then(res => {
        if (res.code == "0000") {
            this.$message({
            message: res.message,
            type: "success"
            });
            this.$emit("finish",this.examUser);
        } else {
            this.$message({
            message: res.message,
            type: "warning"
            });
        }
        });
        }
      });
    }
  }
};
</script>
<style scoped>
div {
  margin-top: 0px;
}

.c {
  margin-top: 10px;
}
.right
{
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/user/changeUD.vue